/**
 * Technical : force explicitely the inclusion of those two runtimes in the final bundle.
 * These runtimes contains the code necessary to do a dynamic CSS import, on the client side.
 */
require('style-loader/lib/addStyles');
require('css-loader/lib/css-base');

import '@webcomponents/custom-elements';

import './modules-es5';

// Global Vendors
import './legacy/vendors-footer';

// - jQuery.validator
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods'; // Locales ?
import './legacy/common/validator.legacy';

import './legacy/common/common.legacy';
import './legacy/common/ajax.legacy';
import './legacy/common/cartridge.legacy';
import './legacy/common/error.legacy';
import './legacy/common/urlParameter.legacy';
import './legacy/common/responseTO.legacy';
import './legacy/common/events.legacy';
import './legacy/common/plugins.legacy';
import './legacy/common/slider.legacy';
import './legacy/common/forms.legacy';
import './legacy/common/pricing.legacy';
import './legacy/common/generic.legacy';
import './legacy/common/location.legacy';

// Browse Page
import './legacy/browse/workshoppaginationbutton.legacy';

// Cart
import './legacy/cart/minicart.legacy';
import './legacy/cart/addtocart.legacy';

// Product Page
import './legacy/product/cross_sell.legacy';

// Utils : globals functions, utilities...
import './legacy/utils/remove-diacritics.legacy';
import './legacy/utils/base.legacy';
import './legacy/utils/bootstrap-select-error.legacy';
import './legacy/utils/push-alert.legacy';
import './legacy/utils/global.legacy';
import './legacy/utils/fallbacks.legacy';

// Maps : Map utils / Wrappers for Gmap & BaiduMap
import './legacy/maps/Map.legacy';
import './legacy/maps/MapBaidu.legacy';
import './legacy/maps/MapGoogle.legacy';
import './legacy/maps/MapCube.legacy';

// Pages specifics

import './legacy/pages/checkout.legacy';
import './legacy/pages/static-content.legacy';
import './legacy/pages/user-account.legacy';
import './legacy/pages/returns.legacy';

// Browse : pagelist
import './legacy/pages/browse/category.legacy';
import './legacy/pages/browse/workshopfilter.legacy';

// Floors : various scopes
import './legacy/floors/map/map.legacy';
import './legacy/floors/breadcrumb/main-breadcrumbs.legacy';
import './legacy/floors/top-message/main-top-message.legacy';
import './legacy/floors/header/main-header.legacy';
import './legacy/floors/gallery/gallery.legacy';
import './legacy/floors/services/decathlon-services.legacy';
import './legacy/floors/footer/main-footer.legacy';
import './legacy/floors/reviews/user-reviews.legacy';
import './legacy/floors/header/main-header-sticky.legacy';
import './legacy/floors/cart-cross-sell/cart-cross-sell.legacy';
import './legacy/floors/product-list/product-list-v2.legacy';
import './legacy/floors/bundles/bundles.legacy';
import './legacy/floors/bundles/bundlesSidebar.legacy';
import './legacy/floors/modal-sidebar/modal-sidebar--bundles.legacy';
import './legacy/floors/product-filters/workshop-product-filters.legacy';
import './legacy/floors/category-intro/category-intro.legacy';
import './legacy/floors/category-tabs/category-tabs.legacy';
import './legacy/floors/sports-advice/sports-advice.legacy';

// Modules : Various functions, utils methods
import './legacy/modules/collapsible-text.legacy';
import './legacy/modules/go-to-top-bottom.legacy';
import './legacy/modules/typeahead.legacy';

// JS Registrer
import './legacy/registrer/RegistredModule.legacy';
import './legacy/registrer/pdmainCartridgeRegistrer.legacy';
import './legacy/registrer/videoFloorRegistrer.legacy';
import './legacy/registrer/CubeVideosModule.legacy';
import './legacy/registrer/bundlesFloorSlider.legacy';
import './legacy/registrer/storeLocatorModule.legacy';
import './legacy/registrer/menuModule.legacy';
import './legacy/registrer/conversionZoneModule.legacy';
import './legacy/registrer/panoplyContextModule.legacy';
import './legacy/registrer/account/accountUtils.legacy';
import './legacy/registrer/account/myReturnsModule.legacy';
import './legacy/registrer/account/myVouchersModule.legacy';
import './legacy/registrer/account/mySportsModule.legacy';
import './legacy/registrer/account/addSportBlockModule.legacy';
import './legacy/registrer/jsRegistrer.legacy';

import { init as initCommons } from './commons/commons.entry';

/** specific country imports */
import { init as initCountrySpecific } from '@/_override/shared/shared-country.entry';
/** end of specific country imports */

import { i18n } from '@/commons/utils';

const debug = false;

// Check if browser support ES6

const supportsES6 = (() => {
  try {
    /* eslint-disable */
    new Function('(a = 0) => a');
    /* eslint-enable */
    return true;
  } catch (err) {
    return false;
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  console.info(`the defined country at build time is : ${COUNTRY}`);

  if (!supportsES6)
    cube.alert.information(i18n('outdatedBrowserWarningMessage'), 0);

  initCommons();
  initCountrySpecific();
  // Init Debug Mode
  if (debug)
    import(/* webpackChunkName: "debug" */ './commons/debug.entry').then(
      ({ init }) => init()
    );

  // if (cube.$id('login-container') && cube.storage.getObject('qa') === true)
  //   import(/* webpackChunkName: "qa-helper" */ './standalone/qa-helper/login/qa-helper-login').then(
  //     ({ init }) => init()
  //   );
  //TODO : remove
  console.info(`the defined country at build time is : ${COUNTRY}`);
});



// WEBPACK FOOTER //
// ./src/dkt-shared.js